/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAuth } from "~contexts/Auth";
import { Routes, Route, useLocation } from "react-router-dom";
import { PrivateRoutes, PublicRoutes } from "~routes/CustomRoutes";
import { ROLES, ROUTES } from "~routes/constants";
import { NotFound, Login, Users } from "~components/Pages";
import RouteGuard from "~routes/RouteGuard";

const Router = () => {
  const location = useLocation();
  const { signed, ValidateUserToken } = useAuth();

  useEffect(() => {
    if (signed) ValidateUserToken();
  }, [signed, location]);

  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route element={<PublicRoutes />}>
        <Route path="/" element={<Login />} />
      </Route>

      {/* ADMIN E USUARIO */}
      <Route element={<PrivateRoutes roles={[ROLES.admin, ROLES.usuario]} />}>
        {ROUTES.filter((r) => r.roles.includes(ROLES.admin) || r.roles.includes(ROLES.usuario)).map(
          ({ to, element, primary, screen, roles }) => (
            <Route
              key={primary}
              path={to}
              element={
                <RouteGuard screen={screen} allowedRoles={roles as ROLES[]}>
                  {element}
                </RouteGuard>
              }
            />
          )
        )}
        <Route
          path="/usuarios"
          element={
            <RouteGuard screen="usuarios" allowedRoles={[ROLES.admin]}>
              <Users />
            </RouteGuard>
          }
        />
      </Route>

      {/* ATENDIMENTO */}
      <Route element={<PrivateRoutes noLayout roles={[ROLES.chat, ROLES.admin]} />}>
        {ROUTES.filter((r) => r.roles.includes(ROLES.chat)).map(
          ({ to, element, primary, screen, roles }) => (
            <Route
              key={primary}
              path={to}
              element={
                <RouteGuard screen={screen} allowedRoles={roles as ROLES[]}>
                  {element}
                </RouteGuard>
              }
            />
          )
        )}
      </Route>
    </Routes>
  );
};

export default Router;
